export default {
  setCollection(state, payload) {
    state.collections = payload;
  },
  setCollectionDetails: (state, payload) => {
    state.collectionDetails = payload;
  },
  resetCollectionDetails(state) {
    state.collectionDetails = null;
  },
};
